import { createAsyncSlice } from 'store/createAsyncSlice';
import { updateInternalTransferAsync } from '../../../../../API/order/escrow/EscrowAPI';

export const { slice: updateInternalTransferSlice, asyncAction: updateInternalTransferAction } = createAsyncSlice(
  'updateInternalTransferSlice',
  updateInternalTransferAsync
);
